<template>
  <form class="dhr-list" @submit.prevent="stopEditing">
    <div class="tbl-view">
      <h4 class="content-subtitle">Overview samples</h4>
      <table class="detail-table">
        <div v-if="isLoaded">
          <div class="detail-table-head">
            <span class="sticky-first-column medium"></span>
            <!-- <span class="medium"></span> -->
            <span
              v-for="(val, index) in checkValues[0].values"
              :key="index"
              :class="val.letter == 'bool' ? 'medium' : 'small'"
              >{{ val.letter == "bool" ? val.IPCName : val.letter }}</span
            >
            <span class="medium">date</span>
          </div>
          <div class="detail-table-head">
            <!-- <span class="sticky-first-column medium"></span> -->
            <span class="medium"></span>
            <span
              v-for="(val, index) in checkValues[0].values"
              :key="index"
              :class="val.letter == 'bool' ? 'medium' : 'small'"
            >
              {{ val.letter != "bool" ? val.IPCName : null }}
              {{ val.letter != "bool" ? val.IPCType : null }}
            </span>
          </div>
          <div class="detail-table-head">
            <span class="sticky-first-column medium no-font-weight nocenter">measure dev</span>
            <!-- <span class="medium"></span> -->
            <span
              v-for="(val, index) in checkDevice"
              :key="index"
              :class="val.letter == 'bool' ? 'medium no-font-weight' : 'small no-font-weight'"
            >
              <div v-if="!isEditing">
                <span class="small no-font-weight">{{ checkDevice[index].value }}</span>
              </div>
              <div v-else>
                <input
                  v-if="val.letter != 'bool'"
                  :key="val.letter"
                  :name="val.letter"
                  :placeholder="val.letter"
                  class="input-width no-font-weight"
                  :isCentered="true"
                  v-model="checkDevice[index].value"
                />
              </div>
            </span>
            <span class="medium"
              >{{
                this.measuringDevice[0] ? this.measuringDevice[0].firstname : ""
              }}
              {{
                this.measuringDevice[0] ? this.measuringDevice[0].lastname : ""
              }}</span
            >
          </div>
          <div class="detail-table-body" v-if="!isEditing">
            <div
              class="body-row"
              v-for="(sample, sampleNo) in checkValues"
              :key="sampleNo"
            >
              <span class="sticky-first-column medium">{{
                "Sample " + (sampleNo + 1)
              }}</span>
              <!-- <span class="medium"></span> -->
              <span
                v-for="(val, index) in sample.values"
                :key="val.IPCTypeID + '-' + index"
                :class="val.letter == 'bool' ? 'medium center' : 'small center'"
                >{{
                  val.IPCValue != null && val.IPCValue != ""
                    ? val.letter === "bool"
                      ? val.IPCValue === "OK"
                        ? "OK"
                        : "NOK"
                      : val.IPCValue
                    : "-"
                }}</span
              >
              <span class="medium center">{{sample.values[0].date | formatDate}}</span>
            </div>
          </div>
          <div class="detail-table-body" v-if="isEditing">
            <div
              class="body-row"
              v-for="(sample, sampleNo) in checkValues"
              :key="sampleNo"
              @click.stop="handleEditRow(sampleNo)"
            >
              <span class="sticky-first-column medium">{{
                "Sample " + (sampleNo + 1)
              }}</span>
              <!-- <span class="medium"></span> -->
              <div v-for="(val, index) in sample.values" :key="index">
                <InputDash
                  v-if="val.letter != 'bool'"
                  :key="val.IPCID + '-' + index"
                  :name="val.IPCID + '-' + index"
                  :placeholder="val.IPCName"
                  class="input-width"
                  :isCentered="true"
                  v-model="val.IPCValue"
                />
                <InputSelect
                  v-else
                  :key="val.IPCID + '-' + index"
                  :name="val.IPCID + '-' + index"
                  class="select-width test"
                  :options="[{ name: '-' }, { name: 'OK' }, { name: 'NOK' }]"
                  :value="val.IPCValue"
                  :hasTopMargin="true"
                  v-model="val.IPCValue"
                  :onFocus="true"
                  @gotFocus="handleEditFocus(sampleNo, index)"
                />
              </div>
            </div>
            <div
              class="body-row"
              v-for="(sample, sampleNo) in defaultChecks"
              :key="sampleNo"
            >
              <span class="large">{{ "Sample " + sampleNo }}</span>
            </div>
          </div>
        </div>
      </table>
    </div>
    <div
      v-if="!isEditing && completed != 1"
      class="icon submit"
      @click="startEditing"
    >
      <BaseIcon name="pen" class="icon" />
    </div>
    <button
      v-if="isEditing && completed != 1"
      class="no-btn icon submit"
      type="submit"
    >
      <BaseIcon name="save" class="icon" />
    </button>
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash";
import InputSelect from "@/components/base/InputSelect";

export default {
  components: {
    BaseIcon,
    InputDash,
    InputSelect,
  },
  props: {
    data: Array,
    totalSamples: Number,
    DHRID: String,
    completed: Number,
    flowID: String,
    measurment: Array,
    checkValues: Array,
    checkDevice: Array,
  },
  data() {
    return {
      receivedInspection: [],
      defaultChecks: [],
      customChecks: [],

      measuringDevice: [],

      checkHeaders: [],
      isLoaded: false,
      stepID: "",
      isEditing: false,
    };
  },
  mounted() {
    this.receivedInspection = this.data;
    this.measuringDevice = this.measurment;
    this.isLoaded = true;
  },

  setup(){
  },
  methods: {
    startEditing() {
      this.isEditing = true;
    },
    handleEditRow(row) {
      this.checkValues[row].values.forEach((value) => {
        if (value.letter == "bool" && value.IPCValue == null) {
          value.IPCValue = "True";
        }
      });
    },
    handleEditFocus(row, child) {
      this.checkValues[row].values[child].IPCValue = "True";
    },
    stopEditing() {
      this.isEditing = false;

      if (this.completed != 1) {
        this.confirmInspection();
      }
    },
    confirmInspection() {
      let date = new Date();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let currentDate =
        date.getFullYear() +
        "-" +
        month +
        "-" +
        day +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();

      var that = this;
      this.$http
        .put(this.$endpoint + "production/dhr/detail/" + this.DHRID, {
          IPC: this.checkValues,
          flowID: this.flowID,
          measurement: this.checkDevice,
        })
        .then(function (response) {
          that.$swal(
            "Inspection has been updated!",
            `Your Inspection has been successfully updated.`,
            "success"
          );
          that.checkValues.forEach((value) => {
            value.post = false;
          });
          that.$emit("refresh", true);
        })
        .catch(function (error) {
          that.$swal(
            "Oops that went wrong?",
            `Please contact the admin with the following info: ${error}`,
            "error"
          );
        });
    },
  },
  watch: {
    data: {
      handler: function () {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/inputs";
@import "@/style/components/buttons";
@import "@/style/pages/dhrdetail.scss";

.no-font-weight{
  font-weight: 200 !important;
}
.nocenter{
  text-align: left !important;
}

.extrasmall{
  font-size: 14px !important;
}

.dhr-list {
  width: 100%;
  max-height: 96%;

  div.tbl-view {
    width: 100%;
    height: 100%;

    .detail-table-body {
      max-height: 420px;
    }
  }
}

table.detail-table {
  width: 100%;
  height: 100%;
  display: block;
  overflow-x: auto;
  overflow-y: auto;
  white-space: nowrap;
}

.sticky-first-column {
  // position: fixed;
  z-index: 10;
  background-color: white;
  height: 16px;
}

.no-completion {
  color: #6a6a6a;
  font-style: italic;
  font-weight: 500;
  font-size: 12px;
}

.no-data {
  color: #6a6a6a;
  font-weight: 400;
  font-style: italic;
  padding-top: 16px;
}

.detail-table-body {
  display: table;
  min-width: 100%;
  width: auto;
}

.detail-table-head {
  span {
    text-transform: capitalize;
    text-align: center;
  }
}

.body-row {
  min-height: 48px !important;

  span {
    text-transform: capitalize;

    &.center {
      text-align: center;
    }
  }
}

.icon.submit {
  position: absolute;
  top: 20px;
  right: 20px;
}

.input-width {
  width: 104px !important;
  margin: 0 8px;
}

.select-width {
  width: 144px !important;
  margin: 0 8px;
}
</style>